export class TagsPaginatedOutDTO {
  tags!: string[];
  total!: number;
}
